import { render, staticRenderFns } from "./MarqiiViews.vue?vue&type=template&id=5f750dca"
import script from "./MarqiiViews.vue?vue&type=script&lang=js"
export * from "./MarqiiViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports